export default __webpack_public_path__ + "static/media/insurance-shield.a2e993d0.svg";